import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import AndroidHandler from 'utils/androidHandler'
import { SelectionStepsV2 } from '../components/SelectionSteps/SelectionStepsV2'
import Header from 'app/BCKSPage/components/Header'
import BCKSProfile from 'app/BCKSPage/components/BCKSProfile'

export const BCKSInvitationFinal = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()

  const handleBackToHome = () => {
    if (androidHandler.enabled) {
      historyUtils.backToApp(() => router.replace('/home'))
    } else {
      router.replace('/home')
    }
  }

  return (
    <div className="min-h-screen max-w-xl mx-auto bg-surface-subdued">
      <Header
        withRightActionButton={false}
        title="Proses Seleksi"
        onBackClick={handleBackToHome}
      />

      <BCKSProfile className="border-b" />

      <div className="h-full">
        <SelectionStepsV2 />
      </div>
    </div>
  )
}
